import { BusinessEstimateWithAccountInfo } from '@lune-fe/dapi-models'
import { CategoryChip, formatToCurrency, MoreCategories } from '@lune-fe/lune-components-lib'
import { TableNew } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import moment from 'moment'
import { FC, RefObject } from 'react'

import { formatNumberWithFallback } from 'utils'
import {
    BusinessEmissionCalculationContextMenu,
    EmissionCalculationRow,
    EstimateTypeName,
    EstimateTypeSlug,
} from 'views/CalculateEmissions/index'

const BusinessEmissionCalculationRow: FC<{
    calculation: BusinessEstimateWithAccountInfo
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
}> = ({ calculation, currentPage, queryParams, pageHistoryRef }) => {
    const formatDate = (date: string) => {
        return moment(date).format('ll')
    }
    const slug = EstimateTypeSlug(calculation.estimateType)
    // Making sure we don't show duplicate categories
    const categories = Array.from(new Set(calculation.categories))
    return (
        <EmissionCalculationRow
            id={calculation.id}
            slug={slug}
            emissionType={EstimateTypeName(calculation.estimateType)}
            estimateType={calculation.estimateType}
            contextMenu={
                <BusinessEmissionCalculationContextMenu
                    calculation={calculation}
                    editable={slug !== undefined}
                />
            }
            currentPage={currentPage}
            pageHistoryRef={pageHistoryRef}
            queryParams={queryParams}
        >
            <TableNew.TableCell colSize={3} oneLineText>
                {calculation.name || EstimateTypeName(calculation.estimateType)}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={1}>{formatDate(calculation.createdAt)}</TableNew.TableCell>
            <TableNew.TableCell colSize={3}>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        maxWidth: '100%',
                        overflow: 'hidden',
                    }}
                >
                    <CategoryChip sx={{ maxWidth: '100%' }} category={categories[0]} />
                    {categories.length > 1 && <MoreCategories items={categories.slice(1)} />}
                </Box>
            </TableNew.TableCell>
            <TableNew.TableCell colSize={2} oneLineText>
                {calculation.accountName}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1}>
                {calculation.value?.value
                    ? formatToCurrency(calculation.value.value, calculation.value.currency)
                    : '--'}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1}>
                {formatNumberWithFallback(calculation.quantity, {
                    decimals: 2,
                    decimalsWhenLessThan: 6,
                    fallback: '--',
                })}
            </TableNew.TableCell>
        </EmissionCalculationRow>
    )
}

export default BusinessEmissionCalculationRow
